import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWindows = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.29336 0.70701C8.65939 0.341266 9.23858 0.317686 9.63125 0.637674L9.70742 0.70701L17.2934 8.29295L17.3617 8.36814C17.6822 8.76092 17.6595 9.34182 17.2934 9.70799L9.70742 17.2939L9.63125 17.3613C9.26461 17.6605 8.7352 17.6605 8.36856 17.3613L8.29336 17.2939L0.706446 9.70799L0.638086 9.63084C0.339357 9.2642 0.339051 8.73461 0.638086 8.36814L0.706446 8.29295L8.29336 0.70701ZM1.41348 8.99998L8.99941 16.5859L16.5863 8.99998L9.00039 1.41404L1.41348 8.99998ZM12.7074 5.99998L9.70742 8.99998L12.7074 12L12.0004 12.707L9.00039 9.70701L6.00039 12.707L5.29336 12L8.29336 8.99998L5.29336 5.99998L6.00039 5.29295L9.00039 8.29295L12.0004 5.29295L12.7074 5.99998Z",
		fill: "black"
	})
});
export default SvgWindows;
